"use strict";

import { ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../config/firebase";
import { PROJECT_SUBTITLES } from "../../ApiEndpoints.js";
import { postWithFirebaseAuth } from "../../utils/firebaseApiClient.js";

export const isSrtFile = (file) => /\.srt$/i.test(file?.name || "");

/**
 * Uploads one SRT to the project's staging folder in Storage and resolves
 * with its object name. The backend copies it into place on attach.
 */
export const uploadSubtitleToStorage = ({ projectId, id, file, onProgress }) => {
  const safeFileName = file.name.replace(/[^A-Za-z0-9._-]+/g, "_");
  const objectName =
    `projects/${projectId}/uploads/subtitles/${id}/${safeFileName}`;
  const uploadTask = uploadBytesResumable(ref(storage, objectName), file);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = snapshot.totalBytes
          ? (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          : 0;
        onProgress?.(progress);
      },
      reject,
      () => resolve(objectName)
    );
  });
};

/**
 * Attaches uploaded SRTs to the project, replacing any existing file for the
 * same role and language. Resolves with the backend's copied subtitles.
 */
export const attachSubtitles = async (projectId, subtitles) => {
  const collectionAssets = subtitles.map((subtitle) => ({
    mediaType: "subtitle",
    subtitleRole: subtitle.role,
    ...(subtitle.languageCode ? { languageCode: subtitle.languageCode } : {}),
    originalFileName: subtitle.fileName,
    storage: { objectName: subtitle.objectName },
  }));
  const response = await postWithFirebaseAuth(PROJECT_SUBTITLES, {
    projectId,
    collectionAssets,
  });
  return response.data?.copiedSubtitles || [];
};
